import { Pipe, PipeTransform } from '@angular/core';
import { htmlGetter } from '../types/grid-helper.types';

@Pipe({
	name: 'gridCellHtml',
	pure: true,
	standalone: true
})
export class GridCellHtmlPipe implements PipeTransform {
	transform(html: string | htmlGetter, item: unknown): string {
		if (typeof html === 'function') {
			return html(item);
		}

		return html;
	}
}
